

export function tr(text: string): string {
    // no translation implemented
    return text;
}
